import React, { Component } from 'react';
import './index.scss';
import { observer } from 'mobx-react';
import nativeInterface from '../../../../native-interact/native';
import { parkStore } from '../../../../mobx/stores/park';
import close from '../../../../assets/imgs/input-delete.png';

// const che = '车扯撤彻澈掣坼撤'
// const wei = '位为未喂维魏微威伟味尾韦胃围惟薇委伪危违'
// const hao = '号好浩豪郝昊皓耗毫壕蒿嚎蚝'

function checkRate(str) {
  const re = /^[0-9a-zA-Z]*$/g;
  if (re.test(str)) {
    return true;
  }
  return false;
}

class AudioInput extends Component {
    state = {
      isRecord: false
    }

    startRecord = () => {
      if (this.state.isRecord) {
        return;
      }
      //  语音识别
      this.setState({
        isRecord: true
      });
      // parkStore.isParknoAudio = true
      nativeInterface.voiceToText();
    }

    closeAudio = () => {
      this.setState({
        isRecord: false
      });
      parkStore.getAudioTxt('');
      this.props.onhideAudio();
    }

    clearAudioTxt = () => {
      this.setState({
        isRecord: false
      });
      parkStore.getAudioTxt('');
      this.startRecord();
    }

    comfirmAudioTxt = () => {
      // 字符串截取
      let str = '';
      for (const codePoint of parkStore.audioParkno) {
        if (checkRate(codePoint)) str += codePoint;
      }
      // 删除掉本地缓存中的车位号
      if (localStorage.getItem('parkingno')) localStorage.setItem('parkingno', '');
      parkStore.form.parkingno = str.toUpperCase();
      this.closeAudio();
    }

    componentDidMount() {

    }

    render() {
      const { showAudio, themeType } = this.props;
      const { audioParkno } = parkStore;
      const { isRecord } = this.state;
      const themeClass = themeType == 'dark' ? 'auido-wrap dark-audio' : 'auido-wrap light-audio';
      if (showAudio) this.startRecord();
      return (
        <div className="audio-mask" style={{ display: showAudio ? 'block' : 'none' }}>
          <div className={themeClass}>
            <img src={close} className="close-audio" onClick={this.closeAudio} alt="关闭" />
            <div className="audio-title">请清晰说出 "车位号"+具体车位</div>
            <div className="audio-title">例如：车位号A00001</div>
            {
              audioParkno
                ? <div>
                  <div className="audio-result">{audioParkno}</div>
                  <div className="audio-btn2">
                    <div className="audio-comfirm" onClick={this.comfirmAudioTxt}>确定</div>
                    <div className="audio-reset" onClick={this.clearAudioTxt}>重录</div>
                  </div>
                  </div>
                : <div>
                  <div className="record-loading">
                    {/* { !isRecord ? '请点击下方图标按钮说话' : '正在识别中...' } */}
                      正在识别中.....
                  </div>
                  {/* <div className="audio-btn" onClick={this.startRecord}>
                      <i className="iconfont icon-luyin"></i>
                  </div> */}
                  </div>
            }
          </div>
        </div>
      );
    }
}

export default observer(AudioInput);
